let id = 1000;

export default function makeGameId() {
  return id++;
}
